/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const UserType = createEnum('USER_TYPE', {
  Corporate: 'CORPORATE',
  Master: 'MASTER',
  Employee: 'EMPLOYEE',
  Supplier: 'SUPPLIER',
  Customer: 'CUSTOMER',
});

export type UserType = EnumSet<typeof UserType>;
